import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

interface CreateAdStatusQueryParams {
  checkoutResponse: string | null;
  selfServeSponsorRequestId: number | null;
}
export default function useCreateAdStatusQueryParams() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [params, setParams] = useState<CreateAdStatusQueryParams>({
    checkoutResponse: null,
    selfServeSponsorRequestId: null,
  });

  useEffect(() => {
    if (searchParams.has('checkoutResponse')) {
      const checkoutResponse = searchParams.get('checkoutResponse');
      const selfServeSponsorRequestId =
        Number(searchParams.get('selfServeSponsorRequestId')) || null;

      setParams({ checkoutResponse, selfServeSponsorRequestId });

      searchParams.delete('checkoutResponse');
      searchParams.delete('selfServeSponsorRequestId');
      setSearchParams(searchParams);
    }
  }, [searchParams, setSearchParams]);

  return params;
}
